import {addQuery} from '@yandex-delivery/utils'
import React from 'react'
import {Redirect} from 'react-router-dom'

import {useConfig} from '../../config'
import {LocationPage} from '../../pages/LocationPage/LocationPage@desktop'
import {TariffsPageContainer} from '../../pages/TariffsPage/desktop'
import {ModalId} from '../../types'
import type {RouterProps} from './types'
import {isPathWithCountry, shouldRedirect} from './utils'

/**@deprecated https://st.yandex-team.ru/CARGODEV-47716 */
export function Router({path, resource}: RouterProps) {
  const {getPath} = useConfig()

  const {countries, zones, defaultCountry, shouldAskCountry} = resource.read()

  if (shouldRedirect(zones, path) || !isPathWithCountry(path)) {
    const params = {modal: shouldAskCountry ? ModalId.COUNTRY_MODAL : undefined}

    return <Redirect to={addQuery(getPath({country: defaultCountry}), params)} />
  }

  const {country, city} = path

  if (!city) {
    return <LocationPage countries={countries} path={path} zones={zones[country]} />
  }

  return <TariffsPageContainer cities={zones[country].allZones} countries={countries} path={path} />
}
